"use client";
import { WorkTimesSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";

const WorkTimes: FC<WorkTimesSectionProps> = () => {
  return (
    <h3
      style={{
        backgroundColor: "black",
        color: "white",
        textAlign: "center",
        padding: 50,
      }}
    >
      WorkTimes
    </h3>
  );
};

export default WorkTimes;
